export const WORDS = [
  'mensk',
  'wicht',
  'heufd',
  'hoast',
  'nuver',
  'geern',
  'lutje',
  'oogen',
  'proat',
  'leven',
  'moeke',
  'kenst',
  'rieks',
  'kloar',
  'stoan',
  'peerd',
  'swiet',
  'heurt',
  'moakt',
  'laive',
  'abuus',
  'baide',
  'leste',
  'waist',
  'raait',
  'orreg',
  'vroug',
  'muike',
  'zukke',
  'stuut',
  'vrauw',
  'pronk',
  'haile',
  'stief',
  'griet',
  'veuls',
  'sloap',
  'stoef',
  'duvel',
  'oomke',

  // spacing for when the words ran out
  'pulen',
  'kaalm',
  'genog',
  'pioot',
  'train',

  // new
  'muive',
  'graas',
  'bloas',
  'turen',
  'glaai',
  'paail',
  'gruin',
  'vloud',
  'noord',
  'flonk',
  'graft',
  'silon',
  'roden',
  'benne',
  'naren',
  'zumen',
  'tusie',
  'swoul',
  'tunen',
  'gaans',
  'sloaf',
  'vroag',

  // rug corpus frequency 100

  'pasen',
  'zenen',
  'bruil',
  'maiwe',
  'ruter',
  'judas',
  'draai',
  'domie',
  'katai',
  'bruur',
  'kemil',
  'doest',
  'gelag',
  'oadem',
  'zulms',
  'leden',
  'opdeu',
  'erven',
  'praan',
  'roene',
  'kluig',
  'gliek',
  'lotje',
  'bruud',
  'bijer',
  'droet',
  'nooit',
  'oogje',
  'benul',
  'dareg',
  'hette',
  'odder',
  'vring',
  'licht',
  'enter',
  'stulp',
  'dioak',
  'zemel',
  'zulde',
  'latte',
  'allin',
  'vlais',
  'sleif',
  'zeere',
  'katte',
  'toeke',
  'loawe',
  'getal',
  'kauen',
  'faien',
  'polka',
  'sofie',
  'zuneg',
  'kroam',
  'nalle',
  'kuien',
  'keren',
  'piepe',
  'praim',
  'vaalg',
  'angen',
  'hoorn',
  'buist',
  'rails',
  'sonst',
  'tromp',
  'admis',
  'verre',
  'beuze',
  'kloun',
  'loods',
  'spoak',
  'kerks',
  'baarg',
  'opins',
  'keile',
  'suzen',
  'krale',
  'aners',
  'etens',
  'weeen',
  'peper',
  'fokke',
  'troef',
  'komen',
  'zeien',
  'poets',
  'vouer',
  'maart',
  'swait',
  'kouke',
  'lijen',
  'bolsk',
  'kokos',
  'vatje',
  'buuts',
  'stang',
]

export const HARD_WORDS = [
  'mensk',
  'wicht',
  'heufd',
  'hoast',
  'nuver',
  'geern',
  'lutje',
  'oogen',
  'proat',
  'leven',
  'moeke',
  'kenst',
  'rieks',
  'kloar',
  'stoan',
  'peerd',
  'swiet',
  'grait',
  'duust',
  'famke',
  'moade',
  'gereg',
  'droet',
  'groul',
  'snoar',
  'bruds',
  'weure',
  'liest',
  'laauw',
  'haark',
  'welle',
  'bulde',
  'vurge',
  'laist',
  'snoar',
  'deure',
  'slont',
  'kaalm',
  'leger',
  'tiels',
  'pioot',
  'genog',
  'roulf',
  'ganze',
  'golve',
  'mizze',
  'bulen',
  'waarf',
  'hudde',
  'klaid',
  'snouk',
  'spiek',
  'bolle',
  'glaai',
  'buuls',

  // padding
  'mens1',
  'wich1',
  'heuf1',
  'hoas1',
  'nuve1',
  'geer1',
  'lutj1',
  'ooge1',
  'proa1',
  'leve1',
  'moek1',
  'kens1',
  'riek1',
  'kloa1',
  'stoa1',
  'peer1',
  'swie1',
  'grai1',
  'duus1',
  'famk1',
  'moad1',
  'gere1',
  'droe1',
  'grou1',
  'snoa1',
  'brud1',

  // new 100 random rug words
  'daank',
  'taail',
  'spiet',
  'wagen',
  'treur',
  'boord',
  'laand',
  'draak',
  'rebat',
  'judas',
  'briek',
  'lofte',
  'ledeg',
  'adres',
  'sprei',
  'schap',
  'dronk',
  'karke',
  'zaipe',
  'dicht',
  'spoit',
  'beder',
  'medde',
  'ketel',
  'onzen',
  'kopen',
  'blied',
  'nigen',
  'dalen',
  'eerns',
  'regel',
  'harry',
  'doags',
  'bonen',
  'troef',
  'kriel',
  'kruut',
  'wever',
  'jovel',
  'vlouk',
  'fokke',
  'strui',
  'dusse',
  'kocht',
  'haard',
  'vlees',
  'gunne',
  'sleup',
  'tgeen',
  'kinds',
  'loven',
  'kauen',
  'maane',
  'velen',
  'wachs',
  'aiweg',
  'steun',
  'harst',
  'doden',
  'ielen',
  'kroem',
  'grens',
  'flare',
  'sjouw',
  'gever',
  'nereg',
  'kluts',
  'knoap',
  'groaf',
  'zaalf',
  'taand',
  'stark',
  'poten',
  'vatje',
  'koane',
  'spiel',
  'kuien',
  'pidde',
  'rekel',
  'troon',
  'welja',
  'hopen',
  'takke',
  'swang',
  'poteg',
  'groep',
  'slink',
  'loage',
  'vezel',
  'vloag',
  'roien',
  'stuit',
  'twiel',
  'oareg',
  'ducht',
  'stuur',
]
